module.exports = __webpack_public_path__ + "img/gold_right.55713caa.png";